/* eslint-disable import/max-dependencies */
import React from "react";
import { Skeleton, Typography } from "@mui/material";
import { BEST_OFFERS_LIST } from "@fas/cpa-state-manager/redux/constants";
import { withStyles } from "@mui/styles";
import { Table, withHookPropsState, withState } from "@fas/cpa-cabinet-ui";
import { useSelector } from "react-redux";
import { getLoadingState } from "@fas/cpa-state-manager/services/selectors/loading";
import { reportTableStyles } from "../../styles";
import withNoData from "../WithNoData";
import NoBestOffersData from "../NoBestOffersData";
import { useBestOffers } from "../../hooks";
import ReportSkeletonLoading from "../Report/ReportSkeletonLoading";
import { useBestOffersInfo } from "../../hooks/useBestOffers/useBestOffers";
import type { Offer } from "../../services/deprecatedApi";

const StyledBestOffers = withStyles(reportTableStyles)(Table<Offer>);
const BestOffersWithLoading = withNoData(StyledBestOffers, NoBestOffersData);
const BestOffers = withState(BestOffersWithLoading, useBestOffers);

const ReportLoading = withHookPropsState(
  ReportSkeletonLoading,
  ({ tableKey }: { tableKey: string }) => {
    const isLoading = useSelector((state) => getLoadingState(state, tableKey));
    const isFetched = useSelector((state) =>
      getLoadingState(state, `${BEST_OFFERS_LIST}-fetched`)
    );
    return {
      isLoading: isLoading && !isFetched,
      fieldsLength: 3,
    };
  }
);

const BestOffersTitle = withState(
  ({ isLoading, title }: { isLoading: boolean; title: string }) => (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {isLoading ? (
        <Skeleton variant="rounded" sx={{ height: 42 }} />
      ) : (
        <Typography
          variant="gradientH4"
          noWrap
          data-testid="best-opportunities-title"
        >
          {title || "Best Opportunities"}
        </Typography>
      )}
    </>
  ),
  useBestOffersInfo
);

const BestOffersComponent = () => (
  <>
    <BestOffersTitle />
    <BestOffers>
      <ReportLoading hookProps={{ tableKey: BEST_OFFERS_LIST }} />
    </BestOffers>
  </>
);

export default BestOffersComponent;
